import { withUpdate } from '@polyu-dip/model-core'
import { Instance, types } from 'mobx-state-tree'
import { BaseEntityModel } from './base-entity'
import { NameModel } from './languages-json'

export const ResourceTypeModel = types
  .compose(BaseEntityModel, NameModel)
  .props({
    id: types.string,
    colorCode: types.string,
    order: types.number,
    isDisabled: types.boolean,
  })
  .extend(withUpdate)
  .named('ResourceTypeModel')

export type ResourceType = Instance<typeof ResourceTypeModel>
